export enum EnvModEnum {
  PROD = 'production',
  DEV = 'development',
}
export enum ModalsEnum {
  HIGHLIGHT = 'highlight',
}

export enum HighlightContentTypeEnum {
  CONTENT = 'content',
  PROMPT = 'prompt',
  CHOICE = 'choice',
  EXPLAIN = 'explain',
}

export enum HighlightColorsEnum {
  YELLOW = 'yellow',
  BLUE = 'blue',
  PINK = 'pink',
}

export enum HighlightUnderlineEnum {
  SOLID = 'solid',
  DASHED = 'dashed',
  DOTTED = 'dotted',
}

export enum HtmlElAltIdEnum {
  HIGHLIGHT_PARENT = 'highlight_parent',
  HIGHLIGHT_TOOLTIP = 'highlight_tooltip',
}

export enum QuizQuestionsOrderEnum {
  NON = 'NON',
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SortEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
